<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container" v-if="!isRevision">
        <div class="row form-campaign">
          <div class="col-md-4">
            <h4>Crie a sua Campanha</h4>
            <span>Informe os dados do produto que deseja divulgar. Essa campanha será exibida no Descontos do Bem e na página da ONG.</span>
          </div>
          <div class="col-md-8">
            <div class="profile-data">

              <div class="row">
                <div class="form-group col-sm">
                  <label>Nome do Produto</label>
                  <input type="text" class="form-control" name="fullname" placeholder="Informe o nome do produto" v-model="name"/>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm">
                  <label>Descrição do Produto</label>
                  <input type="text" class="form-control" name="fullname" placeholder="Informe a descrição do produto" v-model="description"/>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm">
                  <label>Url da Loja/Produto</label>
                  <input type="text" class="form-control" name="url" placeholder="Informe a url da loja ou do produto" v-model="url"/>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm">
                  <label>Preço Regular</label>
                  <input v-money="money" type="text" class="form-control" name="fullname" placeholder="Defina o valor regular do produto" v-model="price"/>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm">
                  <label>Desconto (%)</label>
                  <input type="text" class="form-control" name="fullname" placeholder="Informe o valor de desconto em %" v-model="value"/>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm">
                  <label>Prazo da Campanha</label>
                  <input type="text" class="form-control" name="enddate" placeholder="Informe a data limite da campanha" v-model="endDate"/>
                </div>
              </div>
              
              <div class="row">
                <div class="form-group col-sm">
                  <label>Cupom</label>
                  <input type="text" class="form-control" name="code" placeholder="Insira o código do cupom de desconto" v-model="code"/>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm">
                  <label>ONG Beneficiada</label>
                  <select class="form-control" name="project" v-model="project">
                    <option value="">Selecione...</option>
                    <option v-for="p in projects" :value="p.ProjectId" :key="p.ProjectId">{{p.Info.title}}</option>
                  </select>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
                    {{msg}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>

              <div class="row">
                  <button class="btn submit" v-on:click.stop.prevent="revision()">Revisar Campanha</button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div v-if="isRevision" class="container revision">
        <div class="row form-campaign">
          <div class="col-md-4">
            <h4>Revise a sua Campanha</h4>
            <span>Confirme todos os dados antes de publicar a campanha. Após a publicação, a campanha não poderá mais ser editada.</span>
          </div>
          <div class="col-md-8">
            <div class="profile-data">

              <div class="row">
                <div class="form-group col-sm">
                  <label>Nome do Produto:</label>
                  <h4>{{name}}</h4>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm">
                  <label>Descrição do Produto:</label>
                  <p>{{url}}</p>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm">
                  <label>Url da Loja ou Produto:</label>
                  <p>{{description}}</p>
                </div>
              </div>

              <div class="row" v-if="price && price != ''">
                <div class="form-group col-sm">
                  <label>Preço Regular</label>
                  <h5>{{price}}</h5>
                </div>
              </div>

              <div class="row" v-if="value && value != ''">
                <div class="form-group col-sm">
                  <label>Desconto</label>
                  <h5>{{value}} %</h5>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm">
                  <label>Prazo da Campanha</label>
                  <h5>{{endDate}}</h5>
                </div>
              </div>
              
              <div class="row">
                <div class="form-group col-sm">
                  <label>Cupom</label>
                  <h4>{{code}}</h4>
                </div>
              </div>

              <div class="row" v-if="project">
                <div class="form-group col-sm">
                  <label>ONG Beneficiada</label>
                  <h5>{{getProject(project)}}</h5>
                </div>
              </div>

              <div class="row">
                <button class="btn btn-danger float-left" v-on:click.stop.prevent="revision()">Voltar</button>
                <button class="btn submit float-right" v-on:click.stop.prevent="save()">Publicar Campanha</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'
import {VMoney} from 'v-money'

export default {
  name: 'CreateProject',
  components: {
    Header,
    Footer,
    Loading
  },
  directives: {money: VMoney},
  data () {
    return {
      msg: '',
      showMsg: false,
      loading: false,
      isRevision: false,
      user: null,
      name: null,
      description: null,
      url: null,
      price: null,
      value: null,
      endDate: null,
      code: null,
      project: null,
      projects: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  mounted () {
    this.getProfile()
    this.loadProjects()
  },
  methods: {
    loadProjects(){
      this.$http.get(API.Projects.projects).then((result) => {
        this.projects = result.body;
      });
    },
    getProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((result) => {
        this.user = result.body.user;
        if(!this.user.isPartner){
          this.$router.push('/');
        }
        this.loading = false;
      }, (err) => {
        auth.logout();
        this.$router.push('/login');
      });
    },
    revision(){
      if(this.validate()){
        this.isRevision = !this.isRevision;
      }
    },
    save(){
      this.loading = true;
      if(this.validate()){
        var price = (this.price) ? parseFloat(this.price.replace("R$ ", "").replace(".", "").replace(",", ".")) : null;
        this.$http.post(API.Profile.createCoupon, 
        {name: this.name, description: this.description, url: this.url, price: price, discount: this.discount, 
          endDate: this.endDate, code: this.code, project: this.project},
        {headers: auth.getHeaders()}).then((res) => {
          if(res.body.success === true){
            this.$router.push('/profile?tab=campaigns');
          }else{
            this.showMessage("Ocorreu um erro no cadastro da campanha!");
          }
          this.loading = false;
        }, (err) => {
          console.log(err)
          this.loading = false;
          this.showMessage("Ocorreu um erro no cadastro da campanha!");
        });
      }else{
        this.loading = false;
      }
    },
    validate(){
      if(this.name == null || this.name == ''){
        this.showMessage("Insira um nome de produto para a sua campanha!");
        return false;
      }
      if(this.code == null || this.code == ''){
        this.showMessage("Insira o código de disconto/identificação de produto para a sua campanha!");
        return false;
      }
      return true;
    },
    getProject(projectId){
      var projects = this.projects.filter((p, k) => {
        return p.ProjectId === projectId;
      })
      return projects[0].Info.title
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.msg = "";
      this.showMsg = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.input-photo{
  display: none;
}
.form-campaign{
    margin-top: 20px;
    padding-bottom: 30px;
    .row{
      padding: 20px;
      width: 100%;
      &:last-child{
        border-bottom: none;
      }
    }

    .profile-photo{
      width: 150px;
      height: 150px;
    }

    .change-photo{
      text-decoration: none;
      color: #333;
      margin-left: 20px;
    }

    .profile-data{
      .row{
        padding: 0px;
        border-bottom: none;
      }
    }

    .btn-danger{
      color: #fff;
      border: thin solid #c82333;

      &:hover{
        color: #fff;
        background-color: red;
      }
    }

    .submit{
      margin-left: 15px;
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CreateCampaign.vue